import React, { useEffect } from 'react';

export enum ViewportType {
  'DESKTOP' = 'desktop',
  'TABLET' = 'tablet',
  'MOBILE' = 'mobile',
}

export function useViewport(mobile: number, tablet: number): ViewportType {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return ViewportType.MOBILE;
  }

  const getViewType = (width: number) => {
    if (width >= 0 && width < mobile) {
      return ViewportType.MOBILE;
    }
    if (width >= mobile && width < tablet) {
      return ViewportType.TABLET;
    }
    return ViewportType.DESKTOP;
  };

  const getInitialState = () => window && getViewType(window.innerWidth);

  const [viewport, setIsViewport] = React.useState(getInitialState());

  useEffect(() => {
    const handleResize = () => {
      setIsViewport(getViewType(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return viewport;
}